import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

(function () {
  const byImageslider = document.querySelectorAll(".mb-imageslider");
  let imageSwiper = [];

  for (let i = 0; i < byImageslider.length; i++) {
    const idInt = byImageslider[i].dataset.randomIdInt;

    imageSwiper[i] = new Swiper(byImageslider[i], {
      // modules: [Navigation, Pagination, EffectFade],
      // effect: "fade",
      speed: 500,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 15,
      autoHeight: true,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: "#swiper-pagination-" + idInt,
        clickable: true,
      },
      navigation: {
        nextEl: "#swiper-button-next-" + idInt,
        prevEl: "#swiper-button-prev-" + idInt,
      },
      // fadeEffect: {
      //   crossFade: true,
      // },
      breakpoints: {
        //   640: {
        //     slidesPerView: 2,
        //   },
        920: {
          autoHeight: false,
        },
      },
    });
  }
})();
